import { withModel } from '../../data-providers/model';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { connect } from 'react-redux';
import { getShippingDates } from '../Shipping/duck';
import PromoBanners from './PromoBanners';
import get from 'lodash/get';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { date } from 'src/common/utils/date-time-formatter';

const getPromoMessage = (banner, props) => {
  let text = banner.text || '';
  if (text.includes('%{code}')) {
    text = replaceTextWithValues(text, {
      code: `<span class="highlight color-${banner.promoCodeTextColour}"
style="background-color: ${banner.promoCodeBackground}">${banner.promoCode}</span>`
    });
  }

  if (text.includes('%{lod_')) {
    const shippingDates =
      props.shippingDates.length > 0
        ? props.shippingDates
        : props.model.eagleModel.shippingEstimates;
    let shippingValues = shippingDates.reduce((values, shipping) => {
      const key = shipping.type === 'tracked' ? 'express' : shipping.type.replace('-', '');
      values[`lod_${key}`] = date(
        shipping.xmas_cutoff,
        props.model.countryModel,
        { weekday: 'long', month: 'short', day: 'numeric' }
      );
      return values;
    }, {});
    text = replaceTextWithValues(text, shippingValues);
  }

  return text;
};

const enhance = compose(
  connect(state => ({
    shippingDates: getShippingDates(state),
  })),
  withModel,
  mapProps(props => {
    const defaultPromoBanner = props.model.prismicPromoBannerModel;
    const prismicGeneralBanners = get(props, 'model.prismicGlobalContentModel.general.banners', []);
    const generalBanners = prismicGeneralBanners.map(item => item.banner).filter(banner => banner.text);
    const banners = generalBanners.length > 0 ? generalBanners : [defaultPromoBanner];
    const isRedirected = props.location.pathname.includes('personalized-products') && props.location.search.includes('product-added');
    const addedProductBannerIndex = generalBanners.findIndex(banner => banner.slug === 'product-added-banner');

    // showing Added Product Banner if query params "product-added" exists
    if (!isRedirected && addedProductBannerIndex !== -1) {
      banners.splice(addedProductBannerIndex, 1);
    }
    return {
      banners: banners.map(item => ({
        ...item,
        text: getPromoMessage(item, props),
      })),
    };
  }),
);

export default enhance(PromoBanners);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PromoBanners/index.js